import { render, staticRenderFns } from "./CorporaSearch.vue?vue&type=template&id=34d83131&scoped=true"
import script from "./CorporaSearch.vue?vue&type=script&lang=js"
export * from "./CorporaSearch.vue?vue&type=script&lang=js"
import style0 from "./CorporaSearch.vue?vue&type=style&index=0&id=34d83131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d83131",
  null
  
)

export default component.exports